import { Divider } from '@mui/material';
import { Table } from '@tanstack/react-table';
import { L } from 'harmony-language';
import React from 'react';
import { OrgQueryKeys } from '../../../../api/config';
import { useOrganizationQuery } from '../../../../api/queries/use-organization-query';
import { Driver, DriverProperty, Load } from '../../../../types';
import { GlobalFilter, GlobalFilterObject } from '../../hooks/use-draft-load-table';
import { DraftLoadFilter } from './draft-load-filter';

export type DriverPropertiesFilter = GlobalFilterObject<'driverPropertiesFilter', number>;
interface DriverPropertiesFilterProps {
    table: Table<Load>;
}

export const DriverPropertiesFilter = (props: DriverPropertiesFilterProps) => {
    const { table } = props;
    const { data: driverProperties = [] } = useOrganizationQuery<DriverProperty[]>(OrgQueryKeys.driverProperties);
    const { data: drivers = [] } = useOrganizationQuery<Driver[]>(OrgQueryKeys.drivers);

    function driverPropertiesFilterFn(row: any, driverPropertyId: number) {
        const load: Load = row.original;
        const loadDriver = drivers?.find(driver => driver.id === load.transportedByUserId);
        return !!loadDriver?.driverInfo?.driverPropertyIds?.includes(driverPropertyId);
    }

    function handleDriverPropertyChange(driverPropertyId: number) {
        table.setGlobalFilter((currentGlobalFilter: GlobalFilter): GlobalFilter => {
            const hasDriverProperty = currentGlobalFilter?.some(item => item.type === 'driverPropertiesFilter' && item.value === driverPropertyId);

            if (hasDriverProperty) {
                return currentGlobalFilter?.filter(item => !(item.type === 'driverPropertiesFilter' && item.value === driverPropertyId));
            } else {
                return [
                    ...(currentGlobalFilter || []), {
                        type: 'driverPropertiesFilter',
                        label: driverProperties.find(dp => dp.id === driverPropertyId)?.name || '',
                        value: driverPropertyId,
                        filterFn: driverPropertiesFilterFn,
                    },
                ];
            }
        });
    }

    const globalFilter: GlobalFilter = table.getState().globalFilter;
    const driverPropertiesFilters = globalFilter?.filter(filterItem => filterItem.type === 'driverPropertiesFilter');

    return driverProperties.length > 0 && (
        <>
            <Divider />
            <DraftLoadFilter
                label={L.driverProperties()}
                items={driverProperties}
                selectedIds={driverPropertiesFilters?.map(filterItem => filterItem.value) || []}
                itemLabelFn={dp => dp.name}
                onChange={handleDriverPropertyChange}
            />
        </>
    );
}